export default "__VITE_ASSET__BCWGaqe6__"